import React, { Component } from 'react';
import * as Constants from '../../../common/Global/constants';
import {getLocalStorageVariables, isEmptyVariable, isEmptyArray, handleTokenExpiry} from '../../../common/Global/commonFunctions';
import {Modal} from 'react-bootstrap';
import {DialogSaveButton,UploadSampleLayout} from '../../../common/Global/globalStyles.style';
import AlertDialog from '../../../common/AlertDialog';

let userDetails = getLocalStorageVariables();

class UploadAttachment extends Component {
    constructor(props) {
        super(props);
        this.state = {
            componentDidMountFlag:false,
            showLoader:false,
            submitClickedAtleastOnce:false,
            uploadFileArr:[],
            descriptionArray:[],
            apiErr:"",
            showAlertDialogInfo:false,
            alertDialogMessageInfo:"",
        }
        userDetails = getLocalStorageVariables();
    }

    componentDidMount(){
    }

    componentDidUpdate(prevProps){
        if(JSON.stringify(prevProps) !== JSON.stringify(this.props) && 
        this.props.showUploadAttachmentDialog){
            this.setState({
                componentDidMountFlag:false,
                showLoader:false,
                submitClickedAtleastOnce:false,
                uploadFileArr:[],
                descriptionArray:[],
                apiErr:"",
                showAlertDialogInfo:false,
                alertDialogMessageInfo:"",
            })
        }
    }

    // Handles file uploads by adding file names and descriptions to the state.
    uploadFile = (e) => {
        e.preventDefault();
        const { files } = e.target;
        const newFiles = [];
        const newDescriptions = [];
        let isInvalidFile = false;
        let isFileTooLarge  = false;
        const maxFileSize = 2 * 1024 * 1024; // 2 MB

        const allowedFileTypes = ["image/png", "image/jpg", "image/jpeg", "application/pdf"];
        for (let i = 0; i < files.length; i++){
            // Check file extension
            if (!allowedFileTypes.includes(files[i].type)) {
                isInvalidFile = true;
            }else if(e.target.files[i].size >= maxFileSize){
                isFileTooLarge = true;
            }else{
                newFiles.push(files[i]);
                newDescriptions.push({ fileName: files[i].name, description: "" });
            }
        }

        // Extension invalid then display message
        if (isInvalidFile) {
            this.setState({
                showLoader:false,
                showAlertDialogInfo:true,
                alertDialogMessageInfo:"Please upload file having extensions png, jpg, jpeg and pdf only."
            });
        }else if(isFileTooLarge){
            this.setState({
                showLoader:false,
                showAlertDialogInfo:true,
                alertDialogMessageInfo:"Please upload file size less than "+Constants.MAX_FILE_SIZE+" MB"
            });
        }

        if (newFiles.length > 0) {
            this.setState({
                uploadFileArr: [...this.state.uploadFileArr, ...newFiles],
                descriptionArray: [...this.state.descriptionArray, ...newDescriptions],
            });
        }
    }

    // Updates the description of a specific item in the descriptionArray based on user input.
    handleChange = (e, index) => {
        const updatedArray = [...this.state.descriptionArray];
        updatedArray[index].description = e.target.value;
        this.setState({ descriptionArray: updatedArray });
    }

    // Removes an item from both the uploadFileArr and descriptionArray based on the provided index.
    handleDeleteItemClick = (index) => {
        let uploadFileArrTemp = [...this.state.uploadFileArr];
        uploadFileArrTemp.splice(index,1);

        let descriptionArr = [...this.state.descriptionArray];
        descriptionArr.splice(index, 1);

        this.setState({
            descriptionArray:descriptionArr,
            uploadFileArr:uploadFileArrTemp
        })
    }

    // Handle info alert dialog close event
    handleAlertDialogCloseInfo = () => {
        this.setState({
            showAlertDialogInfo:false,
            alertDialogMessageInfo:""
        });
    }

    /*******************API CALLS*******************/
    uploadDocumentsApi = () => {
        this.setState({
            submitClickedAtleastOnce:true,
        });
        
        const formData = new FormData();
        formData.append('email',userDetails.email);
        formData.append('accessToken',userDetails.accessToken);
        formData.append('frameworkId',this.props.frameworkId);
        formData.append('frameworkClauseId',this.props.frameworkClauseId);
        if(!isEmptyArray(this.state.uploadFileArr)){
            this.state.uploadFileArr.forEach((file) => {
                formData.append('attachments',file);
            })
        }
        const descriptions = [...this.state.descriptionArray];
        formData.append('descriptions',JSON.stringify(descriptions));
        
        fetch(Constants.UploadInternalFrameworkAttachment,{
            method: "POST",
            mode:'cors',
            body: formData
        })
        .then(response => { return response.json(); } )
        .then(data => {
            if(handleTokenExpiry(data.responseCode)) return;
            else if(data.responseCode === Constants.CODE_SUCCESS){
                this.props.uploadAttachmentDialogClose(true);
            }else{
                this.setState({
                    showAlertDialogInfo:true,
                    alertDialogMessageInfo:data.responseMessage
                })
            }
        });
    }
    /*******************API CALLS END HERE*******************/
    
    render() {
        return(
            <>
                <Modal className="upload-doc-sample-dialog custom-dialog" 
                show={this.props.showUploadAttachmentDialog} backdrop="static">
                    <Modal.Header>
                        <h5>Upload Attachment</h5>
                        <button 
                            onClick={this.props.uploadAttachmentDialogClose}
                            type="button" data-dismiss="modal">
                            <span class="material-icons">close</span>
                        </button>
                    </Modal.Header>
                    <hr />
                    <div className="modal-body">
                        {
                            this.state.showLoader &&
                            <div class="loader"></div>
                        }
                        <div className="addnew-modal-form">
                            <div className="search-addnew" style={{alignItems:"center"}}>
                                <div />
                                <div className="search-filter-layout" style={{position:"relative"}}>
                                    <UploadSampleLayout themeSettings={this.props.themeSettings}>
                                        <input 
                                            name="file" 
                                            type="file"
                                            id={"attachment"}
                                            multiple
                                            onChange={this.uploadFile}
                                        />
                                        <label for={"attachment"}>Upload</label>
                                    </UploadSampleLayout>
                                </div>
                            </div>
                            {!isEmptyArray(this.state.uploadFileArr) &&
                                <>
                                    <div className="common-tab-bg mb-3">
                                        <div className="common-table" style={{width:"100%"}}>
                                            <table className="table">
                                                <thead>
                                                    <tr>
                                                        <th>File Name</th>
                                                        <th>Description</th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.uploadFileArr.map((item,index) => {
                                                        return(
                                                            <tr>
                                                                <td>{item.name}</td>
                                                                <td>
                                                                <input
                                                                    type="text"
                                                                    name={`descriptions.${index}.description`}
                                                                    value={this.state.descriptionArray[index]?.description}
                                                                    onChange={(e) => this.handleChange(e, index)}
                                                                    className="form-control mt-1 mb-1"
                                                                    style={{height:34, fontSize:"11.7px"}}
                                                                />
                                                                </td>
                                                                <td>
                                                                    <span className="material-icons delete-doc-row"
                                                                        onClick={this.handleDeleteItemClick.bind(this,index)}>
                                                                    delete
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className="modal-close-save">
                                        <div className="close-save-col">
                                            <button onClick={this.props.uploadAttachmentDialogClose} type="button" className="modal-close">Cancel</button>
                                            <DialogSaveButton
                                            themeSettings={this.props.themeSettings}
                                            onClick={this.uploadDocumentsApi} type="button">Save</DialogSaveButton>
                                        </div>
                                    </div>
                                </>
                            }
                            {
                                isEmptyArray(this.state.uploadFileArr) &&
                                <div class="no-items-layout">
                                    <div class="no-items-card">
                                        <h6>
                                        {
                                            Constants.NO_ATTACHMENT_WARNING
                                        }
                                        </h6>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </Modal>
                <AlertDialog
                    showAlertDialog={this.state.showAlertDialogInfo}
                    handleAlertDialogClose={this.handleAlertDialogCloseInfo}
                    type={Constants.ALERT_TYPE_ALERT}
                    alertDialogMessage={this.state.alertDialogMessageInfo}
                    proceedBtnClick={this.handleAlertDialogCloseInfo}
                    proceedBtnLabel={Constants.ALERT_TYPE_OKAY_LABEL}
                    themeSettings={this.props.themeSettings}
                />
            </>
        );
    }
}

export default UploadAttachment;